







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  CountEmployeeDocumentApprovalRequest,
  Employee,
  GetTarfRequestStatusesResponse,
  Message,
  NavigationRailItem,
  NavigationSubItem,
  RoomStatusCount,
  RoomStatusCounts,
  TarfStatusDetail,
} from "@/api";
import NavigationItem from "@/components/NavigationItem.vue";
import auth from "@/auth";
import FiveStarMomentButton from "@/components/five_star/FiveStarMomentButton.vue";
import * as roleUtils from "@/common/role_utils";
import _ from "lodash";
import statusId from "@/tool/tarfStatus";
import ExpensionNavigationItem from "./ExpansionNavigationItem.vue";
import moment from "moment";
import {
  socket,
  connect,
  updateType,
  NotificationType,
} from "@/tool/socket.io";
import { isSuperAdmin } from "@/common/role_utils";

@Component({
  components: { FiveStarMomentButton, NavigationItem, ExpensionNavigationItem },
})
export default class NavigationRail extends Vue {
  mini = false;

  get navigationItems(): NavigationRailItem[] {
    const items =
      (this.$store.getters["navigation/features"] as NavigationRailItem[]) ||
      [];
    return items.filter(railItem => {
      if (railItem.item) {
        return railItem.item.enabled !== false;
      }
      if (railItem.expansion) {
        return railItem.expansion.enabled !== false;
      }
      return true;
    });
  }

  get companyId(): number | undefined {
    return (
      this.$store.getters.getSelectedCompany?.id ||
      this.$store.getters["superAdmin/selectedCompany"]?.id
    );
  }

  @Watch("companyId")
  onCompanyChanged(newId: number | undefined) {
    if (newId) {
      this.fetchNavigationFeatures();
    }
  }

  async fetchNavigationFeatures() {
    if (this.companyId) {
      await this.$store.dispatch("navigation/fetchFeature", this.companyId);
    } else {
      await this.$store.dispatch("navigation/fetchFeature");
    }
  }

  resolveRootPath(rootPath: string): string {
    if (!rootPath) return "/";
    if (rootPath === "/form") {
      return this.formRoute;
    }
    if (rootPath === "/expense-report") {
      return this.expenseReportPath;
    }
    if (rootPath === "/company-list") {
      return this.companyRoute;
    }
    return rootPath;
  }

  getPrimaryFilter(item: { rootPath?: string; fetchPrimaryNotice?: string }) {
    if (
      item.rootPath === "/room-status" ||
      item.fetchPrimaryNotice === "room/roomStatusCount"
    ) {
      return this.roomStatusCleanFilter;
    }
    if (
      item.rootPath === "/document-approval" ||
      item.fetchPrimaryNotice === "employeeDocuments/employeeDocumentCount"
    ) {
      return this.documentFilter;
    }
    if (
      item.rootPath?.includes("/form") ||
      item.fetchPrimaryNotice === "tarf/tarfStatus"
    ) {
      return this.tarfStatusFilter;
    }
    return undefined;
  }

  getSecondaryFilter(item: {
    rootPath?: string;
    fetchSecondaryNotice?: string;
  }) {
    if (
      item.rootPath === "/room-status" ||
      item.fetchSecondaryNotice === "room/roomStatusCount"
    ) {
      return this.roomStatusDirtyFilter;
    }
    return undefined;
  }

  mapSubItems(subItems: NavigationSubItem[]) {
    if (!subItems) return [];
    return subItems
      .filter(item => item.enabled !== false)
      .map(item => ({
        ...item,
        rootPath: this.resolveRootPath(item.rootPath),
        primaryFilter: this.getPrimaryFilter(item),
        secondaryFilter: this.getSecondaryFilter(item),
      }));
  }

  get isSelfLead() {
    return roleUtils.checkSelfLead();
  }

  get isGuardianAngel() {
    return roleUtils.checkGuardianAngel();
  }

  created() {
    this.connectSocket();
    if (this.$vuetify.breakpoint.smAndDown) {
      this.mini = true;
      this.$store.dispatch("toggleNavRail");
    }
    this.fetchNavigationFeatures();
    if (!isSuperAdmin()) {
      this.fetchStatusesAndCount();
    }

    if (socket) {
      socket.on("/message", (msg: Message) => {
        const from = this.$route.params.id;
        const fetchChat =
          (from == msg.from.id.toString() ||
            roleUtils.selfData().id == msg.from.id ||
            from == msg.group?.toString()) &&
          this.$route.fullPath.includes("chat");
        if (fetchChat) {
          this.$store.dispatch("chat/addChat", msg);
        }
        this.$store.dispatch("chat/fetchChatList");
      });
      socket.on("/notification", (msg: NotificationType) => {
        updateType(
          msg.type,
          this.routeTarfStatus,
          this.documentId,
          this.status,
          msg.submitter,
        );
      });
    }
  }

  connectSocket() {
    if (this.selfInfo && this.selfInfo.firstName) {
      connect(
        this.selfInfo.id,
        this.selfInfo.firstName,
        this.selfInfo.companyId,
      );
    }
  }

  get selfInfo(): Employee {
    const emp = this.$store.getters["getCurrentEmployeeSelf"] as Employee;
    return emp;
  }

  isRole(role: string) {
    return roleUtils.checkSelfRole(role.toLowerCase());
  }

  get routeTarfStatus() {
    const stat = this.$route.params.status;
    if (stat) {
      if (stat === "new") return statusId.new;
      if (stat === "excused") return statusId.excused;
      if (stat === "unexcused") return statusId.unexcused;
      if (stat === "processed") return statusId.processed;
      if (stat === "denied") return statusId.deny;
      if (stat === "resubmit") return statusId.resubmit;
      return -1;
    }
    if (this.$route.path.includes("/form/employee")) return 6;
    return -1;
  }

  get documentId() {
    const id = this.$route.params.documentId;
    if (id) {
      return Number(id);
    }
    return -1;
  }

  get status() {
    const id = this.$route.params.status;
    if (id) {
      return Number(id);
    }
    return -1;
  }

  async fetchStatusesAndCount() {
    const categories = this.$store.dispatch("staffSurvey/getCategories");
    const tarfStatus = this.$store.dispatch("tarf/fetchTarfStatuses", {
      force: false,
      toFetch: this.routeTarfStatus,
    });

    const eventCount = this.$store.dispatch(
      "EventMetricAdmin/fetchEventCount",
      {
        eventId: -1,
        date: moment()
          .local()
          .format("YYYY-MM-DD"),
      },
    );

    const calEventCount = await this.$store.dispatch("calendar/fetchCount");

    // fetch a patient event count
    const pateintCalEventCount = await this.$store.dispatch(
      "patientCalendar/fetchCount",
    );

    const unreadMessageCount = await this.$store.dispatch(
      "chat/fetchUnreadMessageCount",
    );

    const roomStatusCount = await this.$store.dispatch(
      "room/fetchRoomsStatusCount",
    );

    const startDate = moment()
      .startOf("week")
      .format("YYYY-MM-DD");
    const endDate = moment()
      .endOf("week")
      .format("YYYY-MM-DD");

    const gaInspectionCount = await this.$store.dispatch(
      "inspection/fetchInspectionCount",
      { beginAt: startDate, endAt: endDate },
    );

    const handbookCount = await this.$store.dispatch(
      "handbook/fetchHandbookCount",
    );

    const suggestionCount = await this.$store.dispatch(
      "suggestion/fetchSuggestionCount",
    );

    const admissionCount = await this.$store.dispatch(
      "survey/fetchAdmissionSurveyCounts",
    );

    const dischargeCount = await this.$store.dispatch(
      "survey/fetchDischargeSurveyCounts",
    );

    if (this.isRole("owner")) {
      const documentCount = this.$store.dispatch(
        "employeeDocuments/getEmployeeDocumentCount",
      );
      await Promise.all([
        categories,
        tarfStatus,
        eventCount,
        documentCount,
        calEventCount,
        unreadMessageCount,
        pateintCalEventCount,
        roomStatusCount,
        gaInspectionCount,
        handbookCount,
        suggestionCount,
        admissionCount,
        dischargeCount,
      ]);
    } else {
      await Promise.all([
        categories,
        tarfStatus,
        eventCount,
        calEventCount,
        unreadMessageCount,
        roomStatusCount,
        gaInspectionCount,
        handbookCount,
        suggestionCount,
        admissionCount,
        dischargeCount,
      ]);
    }
  }

  tarfStatusFilter(items: GetTarfRequestStatusesResponse) {
    const newStatus = _.find(
      items?.statuses ?? [],
      (status: TarfStatusDetail) => status.id == 0,
    );
    if (newStatus) return newStatus?.count;
    else return null;
  }

  documentFilter(count: CountEmployeeDocumentApprovalRequest[]) {
    return count?.find(
      (doc: CountEmployeeDocumentApprovalRequest) => doc.id === 0,
    );
  }

  get isAdmin() {
    return roleUtils.isAdmin();
  }

  get isSuperAdmin() {
    return this.$store.getters["isSuperAdmin"];
  }

  get formRoute() {
    if (this.isAdmin || this.isSuperAdmin) {
      return "/form/supervisor";
    } else {
      return "/form/employee";
    }
  }

  get expenseReportPath() {
    if (this.isRole("owner") || this.isSuperAdmin)
      return "/expense-report/owner";
    else return "/expense-report/admin";
  }

  get isOpen() {
    const navigationRailIsOpen = this.$store.state.navigationRailIsOpen;
    this.mini = !navigationRailIsOpen;
    return navigationRailIsOpen;
  }

  set isOpen(visible) {
    this.$store.dispatch("setNavRailVisibility", visible);
  }

  currentRoute() {
    return this.$route.path;
  }

  get companyRoute() {
    if (this.$route.path.includes("/company-list")) {
      return this.$route.path;
    }
    return "/company-list";
  }

  async logout() {
    await auth.logout();
    location.reload();
  }

  roomStatusCleanFilter(items: RoomStatusCounts) {
    return items?.find(
      (status: RoomStatusCount) => status.status.toLowerCase() == "clean",
    );
  }

  roomStatusDirtyFilter(items: RoomStatusCounts) {
    return items?.find(
      (status: RoomStatusCount) => status.status.toLowerCase() == "dirty",
    );
  }
}
